function info1(collection) {

    this._show = true;
    this._position = null;
    this._container = collection.childContainer;
    this._collection = collection;
    this._isVisible = false;

    this.distanceDisplayCondition = null;

    this.offsetLeft = 0;

    this.offsetTop = 0;

    this.element = document.createElement('div');
    this.element.style.position = 'absolute';
    this.element.style.top = '0';
    this.element.style.left = '0';
}

Object.defineProperties(info1.prototype, {
    position: {
        get: function () {
            return this._position;
        },
        set: function (value) {
            this._position = value;
            this._collection._markDirty();
        },
    },

    show: {
        get: function () {
            return this._show;
        },
        set: function (value) {
            this._show = value;
            this._collection._markDirty();
        },
    },
});

info1.prototype._setVisible = function (value) {
    if (this._isVisible === value) {
        return;
    }

    this._isVisible = value;

    if (this._isVisible) {
        this._container.appendChild(this.element);
    } else {
        this._container.removeChild(this.element);
    }
};

info1.prototype._updateView = function (scene, camera, occluder) {
    var newViewPos = null;

    if (!this._show || !this._position) {
        this._setVisible(false);
        return;
    }

    if (!occluder.isPointVisible(this._position)) {
        this._setVisible(false);
        return;
    }

    newViewPos = Cesium.SceneTransforms.wgs84ToWindowCoordinates(scene, this._position, {});
    if (!newViewPos) {
        this._setVisible(false);
        return;
    }

    if (this.distanceDisplayCondition) {
        var dist = Cesium.Cartesian3.distance(this._position, camera.positionWC);

        if (dist < this.distanceDisplayCondition.near || dist > this.distanceDisplayCondition.far) {
            this._setVisible(false);
            return;
        }
    }

    this._setVisible(true);

    this._currentViewPos = newViewPos;

    var nx = newViewPos.x + this.offsetLeft;
    var ny = newViewPos.y + this.offsetTop;

    this.element.style.left = nx + 'px';
    this.element.style.top = ny + 'px';
};

export default info1;
